module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/add-user-d7033b36b1287d55cef0cb4499baf143.svg";